import { render, staticRenderFns } from "./Feed.vue?vue&type=template&id=8452e70e&scoped=true&"
import script from "./Feed.js?vue&type=script&lang=js&"
export * from "./Feed.js?vue&type=script&lang=js&"
import style0 from "./Feed.scss?vue&type=style&index=0&id=8452e70e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8452e70e",
  null
  
)

export default component.exports